import { useParams } from "react-router-dom";
import { TableRowActionLink } from "~components/DataTable/components/TableRowActionLink/TableRowActionLink.tsx";

export const ViewFixtureAction = ({ fixtureId }: { fixtureId: string }) => {
  const { customerId, sport, organizationId, seasonId } = useParams();

  return (
    <TableRowActionLink
      to={`/${customerId}/admin/${sport}/${organizationId}/seasons/${seasonId}/fixtures/${fixtureId}`}
      back={`/${customerId}/admin/${sport}/${organizationId}/seasons/${seasonId}/fixtures`}
      linkLabelIntl={"fixtureListPage.table.column.actions.advancedEdit"}
      icon={<i className="fas  fa-eye mr-2" />}
    />
  );
};
